module.exports = __webpack_public_path__ + "mercedes.bd1d721ce8d96914889e.png";